import { type CSSProperties } from 'react'
import { FiExternalLink } from 'react-icons/fi'
import { LinkToCustomScript, useAccess } from '@eggplant/routing'
import { Paragraph } from '@eggplant/pattern-library'

const iconStyle: CSSProperties = {
  alignSelf: 'center'
}

const CustomScriptFieldsetDescription = () => {
  const [isAccess] = useAccess(['dai:admin'])

  return (
    <Paragraph>
      <strong>
        Custom scripts allows an extra file to execute before the test config run.
        {
          isAccess && (
            <>
              {' '}
              See
              {' '}
              <LinkToCustomScript
                isHyperlink
                isInlineLink
                label='link-custom-script'
                openInNewTab
              >
                <FiExternalLink
                  aria-hidden
                  style={iconStyle}
                />
                custom scripts
              </LinkToCustomScript>
              {' '}
              page
            </>
          )
        }
      </strong>
    </Paragraph>
  )
}

export default CustomScriptFieldsetDescription
